import React, { useState } from 'react'
import styled from 'styled-components'

const CancelLink = styled.span`
    padding-left: 15px;
`

const CancelModal = ({ onConfirm, onClose, date }) => {
    return (
        <>
            <div id="modal-cover"></div>
            <div className="modal modal-fixed">
                <p>Are you sure you want to cancel your subscription?</p>
                <p>
                    You will continue to have access until the end of your billing cycle on {date}
                </p>
                <span onClick={onConfirm} className="btn arrow-btn">
                    Yes, Cancel
                </span>
                <CancelLink onMouseDown={onClose}>Close Window</CancelLink>
            </div>
        </>
    )
}

export default CancelModal
